export default "__VITE_ASSET__DyMcoovl__"